import { Injectable, inject, signal } from '@angular/core';
import { ApiSessionService } from './api-session.service';

export type OrderPreviewType = 'purchase-order' | 'sales-order';

export interface OrderPreviewTarget {
  type: OrderPreviewType;
  id: string;
}

/**
 * Order shown in the global order preview modal (<pp-order-preview-modal> in app.html).
 *
 * Links to a PO / SO from outside the Orders module open this modal instead of navigating
 * (see orderPreviewGuard), so the user keeps the page, filters and tabs they were on.
 */
@Injectable({ providedIn: 'root' })
export class OrderPreviewService {
  private readonly _current = signal<OrderPreviewTarget | null>(null);
  readonly current = this._current.asReadonly();

  constructor() {
    // Never keep another user's order open after logout / login.
    inject(ApiSessionService).cleared$.subscribe(() => this.close());
  }

  open(type: OrderPreviewType, id: string): void {
    this._current.set({ type, id });
  }

  close(): void {
    this._current.set(null);
  }
}
